import script from "./TaskSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./TaskSwitch.vue?vue&type=style&index=0&id=7de94c95&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de94c95"]])

export default __exports__